import { useEffect, useState, useContext } from "react";
import { Button, Icon, UserAvatar } from "components/Component";
import getTextColor from "components/custom/getTextColor";
import { Modal, ModalBody, TabContent, Nav, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { serviceGetUsersByRoleId } from "services/users";
import { delay, findUpper, getPermission } from "utils/Utils";
import { servicePutAssignChatUser } from "services/chats";
import Swal from "sweetalert2";
import moment from "moment";
import { useDebounce } from "use-debounce";
import SimpleBar from "simplebar-react";
import { MessagesContext } from "contexts/messagesContext";
import { ChatContext } from "./ChatContext";
// import { serviceSendMessage } from "services/messages";
// import { servicePutTickets } from "services/tickets";

const ChatModalAssign = (props) => {
  const {
    setMessages,
    isModalAssignOpen,
    setIsModalAssignOpen,
    cookies,
    chat,
    setChat,
    setSelectedId,
    userDetail
  } = props;

  const [activeTab, setActiveTab] = useState(0);
  const [search, setSearch] = useState("");
  const [selectedUserId, setSelectedUserId] = useState("");
  const [searchText] = useDebounce(search, 100);
  const { onlineValue } = useContext(MessagesContext);
  const [statusOnlineUsers, setStatusOnlineUsers] = onlineValue;

  const {chatListState, salesListState, filteredChatListState} = useContext(ChatContext);
  const [filteredChatList, setFilteredChatList] = filteredChatListState;
  const [, setChatList] = chatListState;
  const [salesList, setSalesList] = salesListState;
  const [userList, setUserList] = useState([]);
  const [choosenDept, setChoosenDept] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropDown = () => setDropdownOpen(!dropdownOpen);

  let roleFunctions = getPermission()["departments"]?.access || [];

  const salesID = "SALES,CS";

  const filterUsersByChannelDepartment = (users) => {
    const channelDeptId = chat?.channel?.departmentId ?? chat?.tickets?.[0]?.departmentId;
    if (!channelDeptId) {
      return users;
    }
    return users.filter((item) => item.departments?.some((dept) => dept.id === channelDeptId));
  };

  const refreshUserList = async () => {
    let responseGetSales = null;
    let responseGetCS = null;
    setSearch("");

    // segregation of duty implementation
    if (roleFunctions.includes("Access_All_Dept")) {
      responseGetSales = await serviceGetUsersByRoleId(cookies.SIDikey, "", salesID);
      // responseGetCS = await serviceGetUsersByRoleId(cookies.SIDikey, "", csID);
    } else {
      responseGetSales = await serviceGetUsersByRoleId(cookies.SIDikey, cookies.departmentIds, salesID);
      // responseGetCS = await serviceGetUsersByRoleId(cookies.SIDikey, cookies.departmentIds, csID);
    }

    if (!responseGetSales) {
      return;
    }

    if (
      (responseGetSales && new RegExp(/20+/).test(responseGetSales?.status)) ||
      (responseGetCS && new RegExp(/20+/).test(responseGetCS?.status))
    ) {
      const data = filterUsersByChannelDepartment([...responseGetSales.data.data]);
      setUserList(data.filter((item) => item.isActive === true).sort((a, b) => b.status.localeCompare(a.status)));
      setSalesList(data);
    }
  };

  const refreshUserListDept = async (deptId) => {
    let responseGetSales = null;
    let responseGetCS = null;
    // segregation of duty implementation
    responseGetSales = await serviceGetUsersByRoleId(cookies.SIDikey, [deptId ?? chat.channel.departmentId], 'SALES,CS');
    // responseGetCS = await serviceGetUsersByRoleId(cookies.SIDikey, [chat.channel.departmentId], 'CS');

    if (!responseGetSales) {
      return;
    }
    if (
      (responseGetSales && new RegExp(/20+/).test(responseGetSales?.status)) ||
      (responseGetCS && new RegExp(/20+/).test(responseGetCS?.status))
    ) {
      const data = filterUsersByChannelDepartment([...responseGetSales.data.data]);
      setUserList(data.filter((item) => item.isActive === true).sort((a, b) => b.status.localeCompare(a.status)));
      setSalesList(data);
    }
  };

  useEffect(() => {
    if(!isModalAssignOpen){
      setSearch("");
    }else{
      refreshUserList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalAssignOpen]);

  useEffect(() => {
    if (statusOnlineUsers.length === 0) {
      return;
    }

    const uL = userList;
    const uLFinal = [];
    uL.forEach((element) => {
      if (statusOnlineUsers.find((so) => so.id === element.id && so.status === "ONLINE")) {
        element.status = "ONLINE";
      } else if (statusOnlineUsers.find((so) => so.id === element.id && so.status === "OFFLINE")) {
        element.status = "OFFLINE";
      }
      uLFinal.push(element);
    });

    if (!!statusOnlineUsers) {
      setStatusOnlineUsers([]);
    }

    setUserList(
      uLFinal
        .sort((a, b) => b.status.localeCompare(a.status))
        .filter((item) => item.role.name === "SALES" || item.role.name === "CS")
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusOnlineUsers]);

  const assignChat = async () => {
    setSearch("");
    if (selectedUserId) {
      const selectedUser = userList.find((item) => item.id === selectedUserId);
      if (selectedUser.departments.length === 0) {
        Swal.fire("Gagal", "User Tidak memiliki department", "error");
        setSelectedUserId("");
        return;
      }
      const chatDeptId = chat?.channel?.departmentId ?? chat?.tickets[0]?.departmentId;
      if (!chatDeptId) {
        Swal.fire("Gagal", "Jaringan anda bermasalah, mohon refresh.", "error");
        setSelectedUserId("");
        return;
      }
      if (!selectedUser.departments.find((itm) => itm.id === chatDeptId) && selectedUser.status === "ONLINE") {
        Swal.fire("Gagal", "Department Sales tidak sesuai dengan channel.", "error");
        setSelectedUserId("");
        return;
      }
      // if user is offline
      if (selectedUser.status === "OFFLINE") {
        Swal.fire("Gagal", "User Sedang Offline", "error");
        setSelectedUserId("");
        return;
      }
      // if user is not accepting new leads
      if (selectedUser.isLeadReceptionActive === false) {
        Swal.fire(
          "Failed",
          `User is currently not accepting leads${selectedUser.leadReceptionReason ? `: ${selectedUser.leadReceptionReason}` : ""}`,
          "error"
        );
        setSelectedUserId("");
        return;
      }

      const resp = await servicePutAssignChatUser(
        cookies.SIDikey, chat.id, selectedUserId, {chatId : chat.id, newUserId: selectedUserId}
      );

      let newChat;

      if (resp && new RegExp(/20+/).test(resp?.status)) {

        newChat = resp.data;

        chat.user = resp.data.user;
        chat.userId = resp.data.user.id;
        
        chat.unreadCountCS = 1;
        chat.unreadCount = 1;

        if(resp.data.messages && resp.data.messages.length > 0){
          
          const lastMessage = resp.data.messages[0];
          newChat.lastMessage = lastMessage;
          setMessages((messages) => [...messages, lastMessage]);

        }

        setChat((chat) => {return {...newChat, ...chat}});
        
        setSelectedId(null);
        handleAssignLocal();
        setSelectedUserId("");
        setIsModalAssignOpen(false);

        
        Swal.fire("Berhasil", `Assign Chat ke ${newChat.user.firstName} ${newChat.user.lastName}`, "success");
        await delay(500);
        
        if(filteredChatList && filteredChatList.length > 0){
          setFilteredChatList(prevChatList => {
            const currentChatIndex = prevChatList.findIndex(chat => chat.id === newChat.id);
            
            if (currentChatIndex === -1) return prevChatList; // No change if chat not found
            
            // Create new array with current chat at top
            return [
              newChat,
              ...prevChatList.filter((_, index) => index !== currentChatIndex)
            ];
          });
        }

        setChatList(prevChatList => {
          const currentChatIndex = prevChatList.findIndex(chat => chat.id === newChat.id);
          
          if (currentChatIndex === -1) return prevChatList; // No change if chat not found
          //console.log('prev',newChat.user)
          
          // Create new array with current chat at top
          return [
            newChat,
            ...prevChatList.filter((_, index) => index !== currentChatIndex)
          ];
        });

      } else {
        Swal.fire("Gagal", "Assign Chat", "error");
      }
    }
  };

  const handleAssignLocal = async () => {
    
  };

  const renderSalesRow = (item, index) => {
    const isLeadReceptionInactive = item.isLeadReceptionActive === false;
    return (
      <div
        className="card-inner-md"
        key={index}
        style={{ cursor: isLeadReceptionInactive ? "not-allowed" : "pointer", opacity: isLeadReceptionInactive ? 0.5 : 1 }}
        onClick={() => {
          if (isLeadReceptionInactive) return;
          if (item.id === selectedUserId) {
            setSelectedUserId("");
          } else {
            setSelectedUserId(item.id);
          }
        }}
      >
        <div className="user-card">
          <Icon
            key={item.id}
            className={item.id === selectedUserId ? "mr-1" : "invisible mr-1"}
            name="check-circle-fill"
            style={{ fontSize: 18, color: "#4461f2" }}
          />
          <UserAvatar theme={item.theme} text={findUpper(item.firstName)}>
            {item.status === "ONLINE" ? (
              <span className="status dot dot-lg dot-success"></span>
            ) : (
              <span className="status dot dot-lg dot-gray"></span>
            )}
          </UserAvatar>
          <div className="user-info">
            <span className="lead-text">{item.firstName + " " + item.lastName}</span>
            <span className="sub-text">{item.email}</span>
            {isLeadReceptionInactive && (
              <span className="sub-text text-danger">
                Not accepting leads{item.leadReceptionReason ? `: ${item.leadReceptionReason}` : ""}
                {item.leadReceptionResumeAt
                  ? ` (resumes at ${moment.utc(item.leadReceptionResumeAt).local().format("DD/MM/YYYY HH:mm")})`
                  : ""}
              </span>
            )}
          </div>
          <div className="user-action">
            {item.departments.length > 0
              ? item.departments.map((department) => (
                  <span
                    key={department.id}
                    className="badge rounded-pill text-bg-primary"
                    style={{
                      background: department.color || "#ffffff",
                      color: getTextColor(department.color || "#ffffff"),
                    }}
                  >
                    {department.name}
                  </span>
                ))
              : ""}
          </div>
        </div>
      </div>
    );
  };

  const onRefreshClicked = async () => {
    await refreshUserList();
    // setFilteredUsers(userList);
  };

  useEffect(() => {
    // refreshUserList();
    // setFilteredUsers(userList);
  }, []);

  useEffect(() => {
    // //console.log('searchText',searchText);
    if (searchText !== "") {
      const newUsers = [];
      userList.forEach((data) => {
        const fullName = data.firstName + " " + data.lastName;
        if (fullName.toLowerCase().includes(searchText.toLowerCase())) {
          newUsers.push(data);
        }
      });

      //console.log('newUsers', newUsers);

      setFilteredUsers(newUsers);
      setSalesList(newUsers);
    } else {
      refreshUserList();
      setFilteredUsers(userList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  // //console.log(filteredUsers.length, searchText);
  return (
    <Modal
      isOpen={isModalAssignOpen}
      backdrop="static"
      keyboard={false}
      toggle={() => setIsModalAssignOpen(false)}
      className="modal-dialog-centered"
    >
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setIsModalAssignOpen(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <Nav tabs>
            <Dropdown nav isOpen={dropdownOpen} toggle={toggleDropDown}>
              <DropdownToggle nav caret>
                {"All Department" && choosenDept}
                <Icon name="caret-down" ></Icon>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem 
                  style={{ color: activeTab === 0 ? "#4461F2" : "", cursor: "pointer" }}
                  onClick={() => {
                    setActiveTab(0)
                    refreshUserList()
                    setChoosenDept('All Department');

                    // refreshUserListDept('ALL')
                    // setSelectedDepartment('');
                  }}
                >
                  All Department
                </DropdownItem>
                <DropdownItem divider />

                {userDetail.departments.map((dept, i) => {
                  return <DropdownItem
                      key={dept.id}
                      style={{ color: activeTab === i+1 ? "#4461F2" : "", cursor: "pointer" }}
                      onClick={() => {
                        setActiveTab(i+1)
                        setChoosenDept(dept.name);
                        refreshUserListDept(dept.id)
                        // setSelectedDepartment(dept.id);
                      }}
                    >
                      {dept.name}
                    </DropdownItem>
                })}
              </DropdownMenu>
            </Dropdown>

            <Button
              color="transparent"
              onClick={(e) => {
                e.preventDefault();
                onRefreshClicked();
                setChoosenDept('All Department');
              }}
            >
            Refresh
            <Icon className={'ml-1'} name="reload"></Icon> 
          </Button>
          
        </Nav>
        <TabContent activeTab={activeTab}>
          <div className="form-control-wrap">
            <div className="form-icon form-icon-left">
              <Icon name="search"></Icon>
            </div>
            <input
              type="text"
              className="form-round form-control"
              id="default-03"
              placeholder="Search user"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <SimpleBar style={{ maxHeight: "350px", minHeight: "350px" }}>
            {filteredUsers.length && searchText !== "" ? (
              filteredUsers.map((item, index) => renderSalesRow(item, index))
            ) : (salesList.length && searchText === "") || (!salesList.length && searchText === "") ? (
              salesList.map((item, index) => renderSalesRow(item, index))
            ) : (
              <p className="mt-4">No user matched</p>
            )}
          </SimpleBar>
          <Button
            color="primary"
            className="mt-2"
            style={{ width: "100%", justifyContent: "center" }}
            onClick={(e) => {
              e.preventDefault();
              assignChat();
            }}
          >
            Assign
          </Button>
        </TabContent>
      </ModalBody>
    </Modal>
  );
};

export default ChatModalAssign;
